module.exports = __webpack_public_path__ + "static/media/country_af.5a8c2df8.webp";